import React, { useState, useEffect } from 'react';
import { fetchRSSI } from '../../Api/DevicesApi';
import s from './DeviceInfo.module.css';

export default function RSSIInfo({ serialnumber }) {
    const [rssiData, setRssiData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!serialnumber) {
            setLoading(false);
            return;
        }

        const loadRSSI = async () => {
            try {
                setLoading(true);
                const data = await fetchRSSI(serialnumber);
                setRssiData(data);
            } catch (error) {
                console.error('Error loading RSSI:', error);
                setRssiData(null);
            } finally {
                setLoading(false);
            }
        };

        loadRSSI();
    }, [serialnumber]);

    if (loading) {
        return null;
    }

    if (!rssiData || rssiData.rssi === undefined || rssiData.rssi === null) {
        return null;
    }

    const rssiValue = rssiData.rssi;
    let signalLevel = '';
    let signalLevelText = '';

    if (rssiValue === 99) {
        signalLevel = 'unknown';
        signalLevelText = 'Неизвестно или не определяется';
    } else if (rssiValue === 0) {
        signalLevel = 'very-weak';
        signalLevelText = '≤ -113 дБм';
    } else if (rssiValue === 1) {
        signalLevel = 'weak';
        signalLevelText = '-111 дБм';
    } else if (rssiValue >= 2 && rssiValue <= 30) {
        const dbm = -109 + (rssiValue - 2) * 2;
        signalLevel = rssiValue >= 20 ? 'good' : rssiValue >= 10 ? 'moderate' : 'weak';
        signalLevelText = `${dbm} дБм`;
    } else if (rssiValue === 31) {
        signalLevel = 'excellent';
        signalLevelText = '≥ -51 дБм';
    } else {
        return null;
    }

    return (
        <div className={s.rssiContainer}>
                <div className={`${s.listItemValue2} ${s[`rssi-${signalLevel}`]}`}>
                    {signalLevelText}
                </div>
        </div>
    );
}

